<template>
  <v-layout
    v-if="familyVolunteers !== null"
    wrap
  >
    <v-flex xs12>
      <v-layout
        class="mt-4"
        :wrap="$vuetify.breakpoint.smAndDown"
      >
        <v-flex
          lg8
          sm12
          :class="{
            'mb-4': $vuetify.breakpoint.smAndDown,
            'mr-3': $vuetify.breakpoint.mdAndUp,
            sz_background_light: isCurrentEdition
          }"
        >
          <v-layout
            class="pa-3"
            align-center
            fill-height
          >
            <v-flex class="none-growth">
              <AppLogo :width="60" />
            </v-flex>
            <v-flex class="ml-3">
              <h2 class="display-3">
                {{ $t('preview.general_info.summary') }}
              </h2>
              <p
                v-if="family !== null"
                class="f-2"
              >
                {{ $t('label.family_code') | addColons }} {{ family.familyEditionCode }}
              </p>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex
          lg4
          sm12
          class="pa-3"
          :class="{ sz_background_light: isCurrentEdition }"
        >
          <p class="f-16 mb-1">
            {{ $t('preview.general_info.volunteer_title') }}
          </p>
          <h4 class="display-1 mb-2">
            {{ volunteerName }}
          </h4>
          <v-layout
            align-center
            class="f-1 mb-1"
          >
            <v-icon class="mr-2">
              phone
            </v-icon><PhoneNumber :number="volunteerPhone" />
          </v-layout>
          <v-layout
            align-center
            class="f-1"
          >
            <v-icon class="mr-2">
              mail_outline
            </v-icon><BaseEmail :email="volunteerEmail" />
          </v-layout>
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex
      xs12
      class="mt-4"
    >
      <h3 class="display-2">
        {{ $t('preview.general_info.important_info_title') }}
      </h3>
      <ul>
        <li
          v-for="(item, index) in $t('preview.general_info.important_info')"
          :key="index"
          class="f-1"
        >
          {{ item }}
        </li>
      </ul>
    </v-flex>
  </v-layout>
</template>

<script>
import AppLogo from '@/components/widgets/AppLogo';
import PhoneNumber from '@/components/widgets/PhoneNumber.vue';
import BaseEmail from '@/components/widgets/BaseEmail.vue';

import filters from '@/constants/filters';

export default {
    name: 'GeneralInfo',
    components: { AppLogo, BaseEmail, PhoneNumber },
    filters: {
        ...filters
    },
    computed: {
        family () {
            return this.$store.getters['previewForDonor/getPreviewInfo'];
        },
        familyVolunteers () {
            return this.$store.getters['defaultApi/getFamilyVolunteers'];
        },
        volunteerName () {
            return this.familyVolunteers.primaryVolunteer.full_name;
        },
        volunteerPhone () {
            return this.$options.filters.phone(this.familyVolunteers.primaryVolunteer.phone);
        },
        volunteerEmail () {
            return this.familyVolunteers.primaryVolunteer.email;
        },
        isCurrentEdition () {
            return this.$store.getters['family/isCurrentEdition'];
        }
    }
};
</script>

<style scoped></style>
